import React, { useState, useEffect } from 'react'
import ReactECharts from 'echarts-for-react'
import { Col, Row } from 'rsuite'

export default function DoughnutChart({
  compStyle = { height: '400px', width: '100%' },
  seriesData = [],
  onClickCheart = () => {},
  ...props
}) {
  const [chartOption, setChartOption] = useState()

  const optionChart = {
    tooltip: {
      trigger: 'item',
    },
    // legend: {
    //   top: '5%',
    //   left: 'center',
    // },
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: ['40%', '70%'],
        // avoidLabelOverlap: false,
        // label: {
        //   show: false,
        //   position: 'center',
        // },
        // emphasis: {
        //   label: {
        //     show: true,
        //     fontSize: 40,
        //     fontWeight: 'bold',
        //   },
        // },
        // labelLine: {
        //   show: false,
        // },
        data: seriesData,
      },
    ],
  }

  useEffect(() => {
    setChartOption(optionChart)
  }, [])

  const onEvents = {
    click: (params) => {
      // console.log('คลิกที่:', params)
      onClickCheart(params.data)
    },
    // mouseover: (params) => {
    //   console.log('Hover:', params.name)
    // },
  }

  if (!chartOption) {
    return false
  }

  return (
    <div>
      <ReactECharts option={chartOption} style={compStyle} onEvents={onEvents} />
    </div>
  )
}
